module.exports = __webpack_public_path__ + "media/auto_history/rok_produkcji-blue-1ce38b74.svg";